module.exports = __webpack_public_path__ + "fb4c9d48320bf95d667cf9f97e03c85a.svg";